import styled from '@emotion/styled';
import dynamic, { LoaderComponent } from 'next/dynamic';
import { FC } from 'react';
import { KahlerBrushProps } from './KahlerBrush';

const KahlerBrush = dynamic(() => import('./KahlerBrush').then((module) => module.KahlerBrush) as LoaderComponent<KahlerBrushProps>, { ssr: false });

export const StyledKahlerBrushLineThrough = styled.span({
	display: 'inline-block',
	position: 'relative',
});

export const KahlerBrushLineThrough: FC<KahlerBrushProps> = ({ children, ...restProps }) => {
	return (
		<StyledKahlerBrushLineThrough>
			<KahlerBrush
				css={{ zIndex: -1 }}
				{...restProps}
			/>
			{children}
		</StyledKahlerBrushLineThrough>
	);
};
